import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStorage } from '../../shared/services/appStorage.service';
import { MatDialog } from '@angular/material';
import { ModalTemplateComponent } from './modal-template/modal-template.component';
import { UploadEvent } from 'ngx-file-drop';
import { ApiNotificiacionesService } from '../../shared/services/api-notificaciones.service';
import { ModalFirmaComponent } from './modal-firma/modal-firma.component';
import { ModalLogoComponent } from './modal-logo/modal-logo.component';
import { ApiDepartamentosService } from '../../shared/services/api-departamentos.service';
import { ApiLogoService } from 'src/app/shared/services/api-logo.service';
import { ModalErrorComponent } from 'src/app/shared/components/modal-error/modal-error.component';

const ELEMENT_DATA_FIRMAS: any = [
  { nombreFirmas: 'Departamento 1', idFirmas: 10, departamento: { id: 1 } }
];

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css']
})
export class NotificacionesComponent implements OnInit {
  // data
  displayedColumnsNotificaciones: string[] = ['nombre', 'id'];
  dataSourceNotificaciones: any[];

  displayedColumnsFirmas: string[] = ['nombreDepartamento', 'idDepartamento'];
  dataSourceDepartamentos;
  departamentosConFirma;
  logo;
  archivoLogo;

  // loading
  loadingNotificaciones;
  loadingLogo;
  loadingDepartamentos;

  constructor(
    public appStorage: AppStorage,
    private router: Router,
    public dialog: MatDialog,
    private apiNotificacionesService: ApiNotificiacionesService,
    private apiDepartamentoService: ApiDepartamentosService,
    private apiLogoService: ApiLogoService
  ) {}

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    } else {
      this.cargarNotificaciones();
      this.cargarDepartamentos();
      this.cargarLogo();
    }
  }

  // Notificaciones
  cargarNotificaciones() {
    this.loadingNotificaciones = true;

    this.apiNotificacionesService
      .getNotificaciones()
      .then((res: any) => {
        this.dataSourceNotificaciones = res;
        this.dataSourceNotificaciones.sort((e1, e2) => {
          return e1.idTipoEmail - e2.idTipoEmail;
        });
        this.loadingNotificaciones = false;
      })
      .catch(error => {
        this.loadingNotificaciones = false;
      });
  }

  editarNotificacion(notificacion) {
    let departamento = {};

    if (this.departamentosConFirma && this.departamentosConFirma.length > 0) {
      departamento = this.departamentosConFirma[0];
    } else {
      departamento = {
        nombre: 'Departamento de transferencias Económicas',
        firma: {
          comuna: 'Algarrobo',
          direccion: 'Moneda 546',
          gerencia: 'Gerencia Editada',
          idFirma: 15,
          telefono: '+569 67150671',
          web: 'www.gerenciacoordinador.cl'
        }
      };
    }

    const dialogRef = this.dialog.open(ModalTemplateComponent, {
      width: '750px',
      data: {
        notificacion: notificacion,
        logo: this.logo,
        departamento: departamento
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargarNotificaciones();
      }
    });

    return dialogRef;
  }

  // Firma
  cargarDepartamentos() {
    this.loadingDepartamentos = true;

    this.apiDepartamentoService
      .getDepartamentos()
      .then(res => {
        this.dataSourceDepartamentos = res;
        this.departamentosConFirma = [];
        for (const departamento of this.dataSourceDepartamentos) {
          if (departamento.firma && departamento.firma !== null) {
            this.departamentosConFirma.push(departamento);
          }
        }

        this.loadingDepartamentos = false;
      })
      .catch();
  }

  openModalFirma(departamento) {
    const dialogRef = this.dialog.open(ModalFirmaComponent, {
      width: '550px',
      data: {
        departamento: departamento,
        departamentos: this.dataSourceDepartamentos
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargarDepartamentos();
      }
    });

    return dialogRef;
  }

  // Logo
  cargarLogo() {
    this.loadingLogo = true;
    this.apiLogoService
      .getLogo()
      .then((res: any) => {
        this.logo = res.logo + '?' + new Date().getTime();
        this.loadingLogo = false;
      })
      .catch(error => {
        this.loadingLogo = false;
      });
  }

  showModalError(mensaje) {
    this.dialog.open(ModalErrorComponent, {
      width: '400px',
      data: {
        mensaje: mensaje
      },
      disableClose: true
    });
  }

  dropped(event) {
    // Validar si se sube un solo archivo
    if (event.files.length !== 1) {
      this.showModalError('Solo puede subir un archivo a la vez.');
      return;
    }

    this.archivoLogo = event.files[0];

    const nombreArchivo: string = this.archivoLogo.relativePath;
    let nombreSinExtension = '';
    let extension = '';
    if (nombreArchivo.lastIndexOf('.') > 0) {
      nombreSinExtension = nombreArchivo.substr(
        0,
        nombreArchivo.lastIndexOf('.')
      );
      extension = nombreArchivo.substr(
        nombreArchivo.lastIndexOf('.') + 1,
        nombreArchivo.length - nombreArchivo.lastIndexOf('.')
      );
    } else {
      // archivo sin extension
      this.showModalError(
        'Sólo se deben subir archivos con las siguientes extensiones: png, jpg, jpeg y gif.'
      );
      return;
    }

    if (
      extension !== 'png' &&
      extension !== 'jpg' &&
      extension !== 'jpeg' &&
      extension !== 'gif'
    ) {
      // archivo sin extension
      this.showModalError(
        'Sólo se deben subir archivos con las siguientes extensiones: png, jpg, jpeg y gif.'
      );
      return;
    }

    this.openModalLogo();

    // this.compress(event);
  }

  openModalLogo() {
    const dialogRef = this.dialog.open(ModalLogoComponent, {
      width: '550px',
      data: {
        archivo: this.archivoLogo
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cargarLogo();
      }
    });

    return dialogRef;
  }
}
